
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";


@Injectable({
  providedIn: 'root'
})
export class AWSKeys extends  TaxplanIQServices{

    constructor(http: HttpClient) {
        super(http);
    }

    getAWSKeys(obj?): Observable<any> {
        const url = this.interpolateUrl(PATH.S3_CREDENTIALS, null, null);
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

    private handleError(error: HttpErrorResponse) {
        return throwError(error.error);
    }

}
